import React, { useEffect } from 'react';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

const ActionAlert = ({
    showAlert,
    setShowAlert,
    alertDashboardName
}) => {

  useEffect(() => {
    setTimeout(() => {
      setShowAlert(false);
    }, 5000);
  })

  return (
    <Stack sx={{ width: '100%' }} spacing={2}>
      <Alert severity="error" onClose={ () => setShowAlert(false) } >
        <strong> You do not have access to {alertDashboardName}  dashboard currently! </strong>
      </Alert>
    </Stack>
  );
}

export default ActionAlert